import React, { useState, useEffect } from 'react';
import './Kite.css';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat';
import Practice from '../../../Unit3/Module12/Practice';
import PracticeSituation from './../../Practice/PracticeSituation';

/**
 * Plays the celebrate video module shown at the end of each day
 * @param {*} props
 * @returns the HTML code for the celebrate module
 */
export default function KitePractice(props) {
  // Initialize variables to be used later

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const [kites, setKites] = useState(false);
  const [kite1, setKite1] = useState(true);
  const [kite2, setKite2] = useState(false);
  const [kite3, setKite3] = useState(false);
  const [effect1, setEffect1] = useState('bounceIcons');
  const [effect2, setEffect2] = useState('');
  const [effect3, setEffect3] = useState('');
  const [practice, setPractice] = useState('');
  const [displayReview, setDisplayReview] = useState(false);
  const [openPractice, setOpenPractice] = useState(false);
  const [kiteScene, setKiteScene] = useState(true);
  const [displayLearnVideo, setDisplayLearnVideo] = useState(true);
  const [kiteNum, setKiteNum] = useState(0);
  const [learnVideo, setlearnVideo] = useState(props.video1);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const bounceSound = new Audio(generateImageUrl('media/Module1Videos/button_bouncing.mp3'));
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));
  const kite1Img = generateImageUrl('images/Module17Images/Kite+1.svg');
  const kite2Img = generateImageUrl('images/Module17Images/Kite+2.svg');
  const kite3Img = generateImageUrl('images/Module17Images/Kite+3.svg');
  const optionSorry = {
      img: generateImageUrl('images/Module17Images/practice/I_m sorry.png'),
      title: 'I am sorry',
      audioPrompt: 'appfiles/manners/option_sorry.mp3',
  };
  const optionExcuseMe = {
      img: generateImageUrl('images/Module17Images/practice/excuse me.png'),
      title: 'Excuse me',
      audioPrompt: 'appfiles/manners/option_excuse_me.mp3',
  };
  const optionThankYou = {
      img: generateImageUrl('images/Module17Images/practice/thank you.png'),
      title: 'Thank You',
      audioPrompt: 'appfiles/manners/option_thank_you.mp3',
  };
  const optionHelp = {
      img: generateImageUrl('images/Module17Images/practice/help him.png'),
      title: 'Help him',
      audioPrompt: 'appfiles/friends_bullying/option_help.mp3',
  };
  const optionNoHelp = {
      img: generateImageUrl('images/Module17Images/practice/let him do it alone.png'),
      title: 'Let him do it alone',
      audioPrompt: 'appfiles/friends_bullying/option_do_alone.mp3',
  };
  const optionNo = {
      img: generateImageUrl('images/Module17Images/practice/say no.png'),
      title: 'Say no',
      audioPrompt: 'appfiles/friends_bullying/option_no.mp3',
  };
  const optionNoBeSad = {
      img: generateImageUrl('images/Module17Images/practice/don_t be sad.png'),
      title: "Don't be sad",
      audioPrompt: 'appfiles/friends_bullying/option_no_be_sad.mp3',
  };
  const optionSorrySad = {
      img: generateImageUrl('images/Module17Images/practice/i_m sorry you are sad.png'),
      title: "I'm sorry you are sad",
      audioPrompt: 'appfiles/friends_bullying/option_sorry_sad.mp3',
  };
  const optionFavoriteColor = {
      img: generateImageUrl('images/Module17Images/practice/what is your favorite color.png'),
      title: 'What is your favorite color?',
      audioPrompt: 'appfiles/friends_bullying/option_favorite_color.mp3',
  };
  const optionWantSnowCone = {
      img: generateImageUrl('images/Module17Images/practice/do you want a snowcone.png'),
      title: 'Do you want a snow cone?',
      audioPrompt: 'appfiles/friends_bullying/option_want_snow_cone.mp3',
  };
  const optionPlayOutside = {
      img: generateImageUrl('images/Module17Images/practice/what do you like to play outside.png'),
      title: 'What do you like to play outside?',
      audioPrompt: 'appfiles/friends_bullying/option_play_outside.mp3',
  };
  const optionPopsicle = {
      img: generateImageUrl('images/Module17Images/practice/do you want a red or blue popsicle.png'),
      title: 'Do you want a red or blue popsicle?',
      audioPrompt: 'appfiles/friends_bullying/option_popsicle.mp3',
  };
  const optionBullyStop = {
      img: generateImageUrl('images/Module17Images/practice/tell the bully to stop.png'),
      title: 'Tell the bully to stop',
      audioPrompt: 'appfiles/friends_bullying/option_tell_bully_stop.mp3',
  };
  const optionSayMean = {
      img: generateImageUrl('images/Module17Images/practice/say mean things.png'),
      title: 'Say mean things',
      audioPrompt: 'appfiles/friends_bullying/option_say_mean.mp3',
  };
  const optionNotTell = {
      img: generateImageUrl('images/Module17Images/practice/not tell a safe adult.png'),
      title: 'Not tell an adult',
      audioPrompt: 'appfiles/friends_bullying/option_not_tell_adult.mp3',
  };
  const optionWalkAway = {
      img: generateImageUrl('images/Module17Images/practice/walk away and stay away.png'),
      title: 'Walk away and stay away',
      audioPrompt: 'appfiles/friends_bullying/option_walk_away.mp3',
  };
  const optionTellAdult = {
      img: generateImageUrl('images/Module17Images/practice/tell a safe adult.png'),
      title: 'Tell an adult',
      audioPrompt: 'appfiles/friends_bullying/option_tell_adult.mp3',
  };
  const optionRideBike = {
      img: generateImageUrl('images/Module17Images/practice/do you like to ride a bike.png'),
      title: 'Do you like to ride a bike?',
      audioPrompt: 'appfiles/friends_bullying/option_ride_bike.mp3',
  };

  /// /////////////////////////////////////////////

  const friendNote = {
    prompt: 'If your friend gives you a nice note, you should say',
    audioPrompt: 'appfiles/friends_bullying/scenario_friend_note.mp3',
    correctMatch: optionThankYou,
    incorrectMatches: [optionExcuseMe, optionSorry],
  };

  const friendFood = {
    prompt:
      'If your friend asks for help carrying his food from the snack shack, you should',
    audioPrompt: 'appfiles/friends_bullying/scenario_friend_food.mp3',
    correctMatch: optionHelp,
    incorrectMatches: [optionNoHelp, optionNo],
  };

  const friendHurtFeelings = {
    prompt:
      'If your friend tells you she feel sad because someone hurt her feelings, you should say',
    audioPrompt: 'appfiles/friends_bullying/scenario_hurt_feelings.mp3',
    correctMatch: optionSorrySad,
    incorrectMatches: [optionFavoriteColor, optionNoBeSad],
  };

  const friendYesNoQuestion = {
    prompt: 'If you want to ask your friend a yes or no question, you can ask',
    audioPrompt: 'appfiles/friends_bullying/scenario_yes_no_question.mp3',
    correctMatch: optionWantSnowCone,
    incorrectMatches: [optionFavoriteColor, optionPlayOutside],
  };

  const friendWhatQuestion = {
    prompt: 'If you want to ask your friend a what question, you can ask',
    audioPrompt: 'appfiles/friends_bullying/scenario_what_question.mp3',
    correctMatch: optionFavoriteColor,
    incorrectMatches: [optionWantSnowCone, optionRideBike],
  };

  const friendChoiceQuestion = {
    prompt:
      'If you want to ask your friend to choose between two options, you can ask',
    audioPrompt: 'appfiles/friends_bullying/scenario_option_question.mp3',
    correctMatch: optionPopsicle,
    incorrectMatches: [optionWantSnowCone, optionFavoriteColor],
  };

  const bullyStop = {
    prompt:
      'What should you do if someone says or does something to you, or someone else, that is not nice over and over again?',
    audioPrompt: 'appfiles/friends_bullying/scenario_bully_step_1.mp3',
    correctMatch: optionBullyStop,
    incorrectMatches: [optionSayMean, optionNotTell],
  };

  const bullyWalkAway = {
    prompt: 'After you have told the bully to stop bullying you, you should',
    audioPrompt: 'appfiles/friends_bullying/scenario_bully_step_2.mp3',
    correctMatch: optionWalkAway,
    incorrectMatches: [optionSayMean, optionNotTell],
  };

  const bullyTellAdult = {
    prompt:
      'After you have told the bully to stop and you have walked away and stayed away, you should',
    audioPrompt: 'appfiles/friends_bullying/scenario_bully_step_3.mp3',
    correctMatch: optionTellAdult,
    incorrectMatches: [optionSayMean, optionNotTell],
  };

  const titles = [
    ['Say nice things', 'Do nice things', 'Show empathy'],
    ['Yes/No Question', 'What Questions', 'Choice Questions'],
    ['How to stop bullying', 'How to stop bullying', 'How to stop bullying'],
  ];
  const options = [
    [friendNote, friendFood, friendHurtFeelings],
    [friendYesNoQuestion, friendWhatQuestion, friendChoiceQuestion],
    [bullyStop, bullyWalkAway, bullyTellAdult],
  ];
  const [Exit, setExit] = useState(
    generateImageUrl('images/Images/close.png')
  );
  // CSS code for the back button


  const displayPractice = (num) => {
    setPractice(
      <PracticeSituation
        options={[options[props.module.currentday - 1][num - 1]]}
        title={titles[props.module.currentday - 1][num - 1]}
        setDisplayPractice={setOpenPractice}
        background={props.background}
        stepComplete={''}
        module={props.module}
        next={() => {
          if (num === 1) {
            setEffect1('');
            setEffect2('bounceIcons');
            setKite2(true);
            sleep(700).then(() => {
              bounceSound.play()
            });
          } else if (num === 2) {
            setEffect2('');
            setEffect3('bounceIcons');
            setKite3(true);
            sleep(700).then(() => {
              bounceSound.play()
            });
          } else if (num === 3) {
            setDisplayReview(true);
            setKiteScene(false);
            setOpenPractice(false);
          }
        }}
      />
    );
    setOpenPractice(true);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // The actual HTML code that determines whether to show the module above.
  return (
    <>
      {openPractice && practice}
      {kiteScene && !openPractice && (
        <div
          className='kiteScene'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          {displayLearnVideo && (
            <CloudfrontVideoFormat
              source={learnVideo}
              back={'unit4'}
              background={props.background}
              close={props.setDisplayPractice}
              ended={() => {
                setDisplayLearnVideo(false);
                setKites(true);
                sleep(700).then(() => {
                  bounceSound.play()
                });
              }}
            />
          )}
          {kites && (
            <div className='dog_kite'>
              {(
                <div
                  className='kite1'
                  style={kite1 ? {} : { opacity: 0, pointerEvents: 'none' }}
                  onClick={() => {
                    touchSound.play()
                    sleep(500).then(() => {
                      displayPractice(1);
                    });
                  }}
                >
                  <img alt='' className='kite1' id={effect1} src={kite1Img} />
                </div>
              )}
              {(
                <div
                  className='kite2'
                  style={kite2 ? {} : { opacity: 0, pointerEvents: 'none' }}
                  onClick={() => {
                    touchSound.play()
                    sleep(500).then(() => {
                      displayPractice(2);
                    });
                  }}
                >
                  <img alt='' className='kite2' id={effect2} src={kite2Img} />
                </div>
              )}
              {(
                <div
                  className='kite3'
                  style={kite3 ? {} : { opacity: 0, pointerEvents: 'none' }}
                  onClick={() => {
                    touchSound.play()
                    sleep(500).then(() => {
                      displayPractice(3);
                    });
                  }}
                >
                  <img alt='' className='kite3' id={effect3} src={kite3Img} />
                </div>
              )}
              {<img alt='' className='animateDog' src={props.animal} />}
            </div>
          )}
        </div>
      )}
      {displayReview && (
        <Practice
          reviewVideo={props.video2}
          setDisplayPractice={props.setDisplayPractice}
          background={props.background}
          stepComplete={'MODULE17_SET_stepCompleted'}
          module={props.module}
          unit4={true}
        />
      )}
    </>
  );
}
